import { odooApiFetch } from "app/utils/auth";
import { isMapConfigFallbackError } from "app/utils/apiErrorHandler";
import {
  ActiveRoutingProviderPayload,
  MapTileConfig,
  resolveDashboardMapTileConfig,
} from "app/utils/mapTileConfig";

let cachedMapConfig: MapTileConfig | null = null;
let loadPromise: Promise<MapTileConfig> | null = null;

export async function loadDashboardMapTileConfig(
  accessToken: string,
  apiRoot: string
): Promise<MapTileConfig> {
  if (cachedMapConfig) {
    return cachedMapConfig;
  }

  if (!loadPromise) {
    loadPromise = (async () => {
      let config = resolveDashboardMapTileConfig(undefined);
      try {
        const activeProvider = await odooApiFetch<ActiveRoutingProviderPayload>(
          `${apiRoot}/routing/active_provider`,
          accessToken
        );
        config = resolveDashboardMapTileConfig(activeProvider);
      } catch (configError) {
        if (!isMapConfigFallbackError(configError)) {
          loadPromise = null;
          throw configError;
        }
      }
      cachedMapConfig = config;
      return config;
    })();
  }

  return loadPromise;
}

export function clearDashboardMapTileConfigCache(): void {
  cachedMapConfig = null;
  loadPromise = null;
}
